import {
  Breadcrumb,
  Button,
  Divider,
  Dropdown,
  Flex,
  Form,
  Input,
  message,
  Space,
  Spin,
  Typography,
  Image,
} from "antd";
import React from "react";
import { IoArrowDownOutline } from "react-icons/io5";
import {
  dataDefaultFetch,
  getDataAPI,
  patchDataAPI,
} from "../../../utils/fetchData";
import { useSelector } from "react-redux";
const { Title, Text } = Typography;

export default function AdminContents() {
  const [contents, setContents] = React.useState(dataDefaultFetch);
  const [key, setKey] = React.useState("Choose a page");
  const [form] = Form.useForm();

  const auth = useSelector((state) => state.auth);

  const items = [
    {
      label: "Choose a page",
      key: "Choose a page",
      disabled: true,
    },
    {
      label: "Home",
      key: "home",
    },
    {
      label: "Tour",
      key: "tour",
    },
    {
      label: "Contact",
      key: "contact",
    },
    {
      label: "Blog",
      key: "blog",
    },
  ];

  async function getBlog() {
    try {
      setContents({ ...contents, loading: true });
      const res = await getDataAPI(`contents/one/${key}`);
      setContents({
        ...contents,
        data: res.data?.data,
        loading: false,
        total: res.data?.total,
      });
    } catch (error) {
      setContents({ ...contents, data: null, loading: false, error: error });
    }
  }

  async function handleSubmitContents(e) {
    try {
      await patchDataAPI(`contents/edit/${key}`, e, auth?.token);
      message.success("Sửa thành công nội dung!");
    } catch (error) {
      message.error(
        error?.response?.data?.statusText || error?.response?.data?.msg
      );
    }
  }

  React.useEffect(() => {
    if (key) {
      getBlog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  React.useEffect(() => {
    if (contents.data) {
      const editData = { ...contents.data };
      form.setFieldsValue(editData);
    }
  }, [contents.data, form]);

  const handleClickItem = (e) => {
    setKey(e.key);
  };
  return (
    <Space
      direction="vertical"
      size="middle"
      style={{ display: "flex", flexDirection: "column" }}
    >
      <Divider orientation="left" variant="dotted">
        Rank Seo Contents
      </Divider>
      <Dropdown menu={{ items, onClick: handleClickItem }}>
        <Button>
          <Space>
            {String(key).charAt(0).toUpperCase() + String(key).slice(1)}
            <IoArrowDownOutline />
          </Space>
        </Button>
      </Dropdown>
      <Spin spinning={contents.loading} />
      {!contents.loading && contents.data && (
        <>
          <div style={{ maxWidth: "500px" }}>
            <Title level={3}>Preview</Title>
              <Flex justify="space-between">
                <div style={{width: "60%"}}>
                  <Breadcrumb
                    items={[
                      {
                        title: (
                          <a
                            href={`${window.location.origin}/${
                              key === "home" ? "" : key
                            }`}
                            target="__blank"
                          >
                            {window.location.origin}/{key === "home" ? "" : key}
                          </a>
                        ),
                      },
                    ]}
                  />
                  <Title level={3} style={{ color: "#1677ff" }}>
                    {contents.data?.title}
                  </Title>
                  <p style={{ textAlign: "left" }}>
                    <Text type="secondary">{contents.data?.desc}</Text>
                  </p>
                </div>
                <Image width={"35%"} height={170} src={contents.data?.url_img} />
              </Flex>
          </div>

          <Form
            name="contents"
            form={form}
            onFinish={handleSubmitContents}
            autoComplete="off"
            layout="vertical"
            style={{ maxWidth: "500px" }}
          >
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Please input the title!" }]}
            >
              <Input maxLength={70} showCount />
            </Form.Item>
            <Form.Item
              label="Description"
              name="desc"
              rules={[
                { required: true, message: "Please input the description!" },
              ]}
            >
              <Input.TextArea maxLength={160} showCount />
            </Form.Item>
            <Form.Item
              label="Url Image"
              name="url_img"
              rules={[
                { required: true, message: "Please input the image url!" },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item label={null}>
              <Button type="primary" htmlType="submit">
                Save Changes
              </Button>
            </Form.Item>
          </Form>
        </>
      )}
    </Space>
  );
}
